import {

  MelcoModelsUserListItem,
  useAPIQuery,
  UserManagementApi,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";
import { useTable } from "../table/useTable";
import { useTableErrorComponent } from "../table/useTableErrorComponent";
import { DigitizingOrdersLogsUsersListFiltersType } from "./DigitizingOrdersLogsUsersListFiltersType";

export const useDigitizingOrdersLogsUsers = (allSummitUsers?: boolean) => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQuery,
    searchQueryChange,
  } = useTable<MelcoModelsUserListItem, DigitizingOrdersLogsUsersListFiltersType>({
    // pageSizeOptions: [10, 20],
    // pageSize: 20,
  });

  //const baseApiConfig = useBaseAPIConfig();
  const query = useAPIQuery(
    UserManagementApi,
    ["users", currentPage, pageSize, filters, sortBy(), searchQuery],
    async (api) => {
      //const api = new UserManagementApi(baseApiConfig({ token }));
      console.log({ filters, currentPage, pageSize });
      let response;
      response = await api.userGetList({
        sortBy: sortBy(),

        searchText:
          filters?.searchText && !isEmpty(filters.searchText)
            ? filters.searchText
            : "",
      });

      return response?.list ? response?.list : [];
    },
    {
      queryOptions: {
        keepPreviousData: false,
        enabled: !!(filters?.searchText && !isEmpty(filters.searchText)),
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    searchQuery,
    searchQueryChange,
    errorComponent,
    ...query,
  };
};
